import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import Alert from '/@/components/bayer/alert';
import settings from '/@/core/settings';
import { useResendVerificationEmail } from '/@/hooks/identity';
import { _ } from '/@/locale';
import { getUser } from '/@/store/session/selectors';

const EmailVerificationAlert = () => {
    const user = useSelector(getUser);
    const resendVerificationEmail = useResendVerificationEmail();
    const isVerified = user?.verified_email;
    const hasInternalEmail = settings.internalProfileEmailDomains.includes(user?.email.split('@')[1]);

    if (isVerified) return null;
    if (!hasInternalEmail && !user?.validated_type) return null;

    return (
        <Stack direction='row' alignItems='center' gap={2} sx={{ width: '100%' }}>
            <Alert
                severity='danger'
                sx={{ width: '100%', alignItems: 'center' }}
                actions={[
                    {
                        label: _('Verificar correo'),
                        onClick: () => resendVerificationEmail.trigger(),
                        kind: 'link',
                        loading: resendVerificationEmail.isMutating,
                    },
                ]}
            >
                {_(
                    'Verificá tu dirección de correo para acceder a todas las funcionalidades. Hacé clic en el botón para que te enviemos el mail de verificación.'
                )}
            </Alert>
        </Stack>
    );
};

export default EmailVerificationAlert;
